import React from 'react';
import { motion } from 'framer-motion';

const variants = {
    primary: "bg-brand-primary text-white hover:bg-brand-secondary shadow-lg shadow-brand-primary/30",
    secondary: "bg-slate-850 text-white hover:bg-slate-700 shadow-lg shadow-slate-900/20",
    outline: "border-2 border-brand-primary text-brand-primary hover:bg-brand-primary/10",
    ghost: "text-slate-600 hover:bg-slate-100 hover:text-slate-900",
    danger: "bg-red-500 text-white hover:bg-red-600 shadow-lg shadow-red-500/30"
};

const Button = ({
    children,
    variant = 'primary',
    className = '',
    onClick,
    disabled = false,
    type = 'button',
    fullWidth = false
}) => {
    return (
        <motion.button
            whileHover={{ scale: disabled ? 1 : 1.02 }}
            whileTap={{ scale: disabled ? 1 : 0.98 }}
            className={`
        px-6 py-3 rounded-xl font-semibold transition-colors duration-200 
        flex items-center justify-center
        ${variants[variant] || variants.primary}
        ${fullWidth ? 'w-full' : ''}
        ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
        ${className}
      `}
            onClick={!disabled ? onClick : undefined}
            disabled={disabled}
            type={type}
        >
            {children}
        </motion.button>
    );
};

export default Button;
